"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAttributeCount = void 0;
const lodash_1 = require("lodash");
const momUtils_1 = require("./momUtils");
const helper_1 = require("../config/helper");
const getStructureSpaceAttributesCount = (spaceCatTypeCount, structureInfo) => {
    let structureSpaceAttributesCount = '';
    const spaceCats = Object.keys(spaceCatTypeCount);
    for (let i = 0; i < spaceCats.length; i += 1) {
        const spaceTypes = Object.keys(spaceCatTypeCount[spaceCats[i]]);
        for (let j = 0; j < spaceTypes.length; j += 1) {
            structureSpaceAttributesCount +=
                `${structureInfo},spaceAttributes,${spaceCats[i]},${spaceTypes[j]},,${spaceCatTypeCount[spaceCats[i]][spaceTypes[j]]}\r\n`;
        }
    }
    return structureSpaceAttributesCount;
};
const getStructureLevelsCount = (levelIds, structureInfo) => `${structureInfo},levels,,,,${levelIds.length}\r\n`;
const getStructureEntrancesCount = (entranceList, structureInfo) => `${structureInfo},entrances,,,,${entranceList.length}\r\n`;
const getStructureParkingRestrictionsCount = (parkingRestrictionsCount, structureInfo) => {
    let structureParkingRestrictionsCount = '';
    const parkingRestrictionsProp = Object.keys(parkingRestrictionsCount);
    for (let i = 0; i < parkingRestrictionsProp.length; i += 1) {
        const restrictionsCount = parkingRestrictionsCount[parkingRestrictionsProp[i]] || 0;
        structureParkingRestrictionsCount += `${structureInfo},parkingRestrictions,,,${parkingRestrictionsProp[i]},${restrictionsCount}\r\n`;
    }
    return structureParkingRestrictionsCount;
};
const getStructureSpaceGroupsCount = (spaceGroupsCount, structureInfo) => {
    let structureSpaceGroupsCount = '';
    const spaceGroupsProps = Object.keys(spaceGroupsCount);
    for (let i = 0; i < spaceGroupsProps.length; i += 1) {
        const sgCount = spaceGroupsCount[spaceGroupsProps[i]] || 0;
        structureSpaceGroupsCount += `${structureInfo},spaceGroups,,,${spaceGroupsProps[i]},${sgCount}\r\n`;
    }
    return structureSpaceGroupsCount;
};
const getOccupantsAttributesCount = (occupantAttributes, siteInfo) => {
    let occupantAttributesCount = '';
    const occupantsProps = Object.keys(occupantAttributes);
    for (let i = 0; i < occupantsProps.length; i += 1) {
        const occupantAttCount = occupantAttributes[occupantsProps[i]] || 0;
        occupantAttributesCount += `${siteInfo},occupantAttributes,,,${occupantsProps[i]},${occupantAttCount}\r\n`;
    }
    return occupantAttributesCount;
};
const getStructureSpacesNamesCount = (namesForSpacesCount, structureInfo) => `${structureInfo},namesForSpaces,,,,${namesForSpacesCount}\r\n`;
const getSpaceGroupAccrossLevelCount = (spaceGroupForSiteCount, siteInfo) => `${siteInfo},spaceGroupsAcrossLevel,,,,${spaceGroupForSiteCount || 0}\r\n`;
const getInternalAddressCount = (internalAddressCount, siteInfo) => `${siteInfo},internalAddress,,,,${internalAddressCount || 0}\r\n`;
const getLinkedTopologiesCount = (linkedTopologiesCount, siteInfo) => `${siteInfo},linkedTopologies,,,,${linkedTopologiesCount || 0}\r\n`;
const getLinkedSpacesCount = (linkedSpacesCount, siteInfo) => `${siteInfo},linkedSpaces,,,,${linkedSpacesCount || 0}\r\n`;
const getTopologyAttributesCount = (topologyAttributes, siteInfo) => {
    let topologyAttributesCount = '';
    const topologyProps = Object.keys(topologyAttributes);
    for (let i = 0; i < topologyProps.length; i += 1) {
        const topologyAttCount = topologyAttributes[topologyProps[i]] || 0;
        topologyAttributesCount += `${siteInfo},topologyAttributes,,,${topologyProps[i]},${topologyAttCount}\r\n`;
    }
    return topologyAttributesCount;
};
/**
 * It will generate attribute count report for the given mom
 * @param mom - mom feature collection
 * @returns json object with attributes count
 */
const generateAttributeCount = (mom, options) => {
    const site = (0, lodash_1.find)(mom.features, { momType: 'indoor.Site' });
    (0, helper_1.logMsg)(`Generating Attribute count report for site - ${site?.properties?.placeProperties?.names[0].name || site?.id}`);
    const structureList = (0, lodash_1.filter)(mom.features, { momType: 'indoor.Structure' });
    const report = { structureData: {}, siteData: { siteId: site?.id } };
    let reportCsv = 'atrributes,id,sub_attributes,space_category,space_type,properties,count\r\n';
    structureList.forEach((strObj) => {
        const levelList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'indoor.Level' && feature.properties.structure.id === strObj.id &&
            (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED');
        const levelIds = levelList.map((levelObj) => levelObj.id);
        const spacesList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'indoor.Space' &&
            (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED' &&
            levelIds.includes(feature.properties.level.id));
        const parkingRestrictionsList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'indoor.Space' &&
            (feature.properties.spaceType === 'PARKING_SPOT' || feature.properties.spaceType === 'PARKING_SECTION') &&
            (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED' &&
            levelIds.includes(feature.properties.level.id));
        // SpaceGroup at levels for the specified structure
        const spaceGroupsList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'indoor.SpaceGroups' &&
            feature.properties.level &&
            (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED' &&
            levelIds.includes(feature.properties.level.id));
        // checking features having name property set
        const namesSpaceList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'indoor.Space' &&
            !!feature.properties.names &&
            (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED' &&
            levelIds.includes(feature.properties.level.id));
        // Get the list of Entrances in the structure of the map
        const entranceList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'indoor.Entrance' &&
            (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED' &&
            levelIds.includes(feature.properties.level.id));
        const spaceCatTypeCount = (0, momUtils_1.getspaceCatTypeCount)(spacesList);
        const parkingRestrictionsCount = (0, momUtils_1.getParkingRestrictionsCount)(parkingRestrictionsList);
        const spaceGroupsCount = spaceGroupsList && (0, momUtils_1.getSpaceGroupsCount)(spaceGroupsList);
        const namesForSpacesCount = namesSpaceList.flatMap((feature) => feature.properties.names).filter((obj) => obj && !!obj.name).length;
        report.structureData[strObj.id] = {
            spaceAttributes: spaceCatTypeCount,
            levels: levelIds.length,
            entrances: entranceList.length,
            parkingRestrictions: parkingRestrictionsCount,
            spaceGroups: spaceGroupsCount || 0,
            namesForSpaces: namesForSpacesCount,
        };
        if (!options?.reportInJsonFormat) {
            const structureInfo = `Structure,${strObj.id}`;
            reportCsv +=
                getStructureSpaceAttributesCount(spaceCatTypeCount, structureInfo) +
                    getStructureLevelsCount(levelIds, structureInfo) +
                    getStructureEntrancesCount(entranceList, structureInfo) +
                    getStructureParkingRestrictionsCount(parkingRestrictionsCount, structureInfo) +
                    getStructureSpaceGroupsCount(spaceGroupsCount, structureInfo) +
                    getStructureSpacesNamesCount(namesForSpacesCount, structureInfo);
        }
    });
    const spaceGroupsForSite = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'indoor.SpaceGroups' &&
        !feature.properties.level &&
        (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED')[0];
    const spaceGroupForSiteCount = spaceGroupsForSite && spaceGroupsForSite.properties.spaceGroups &&
        spaceGroupsForSite.properties.spaceGroups.length;
    report.siteData.spaceGroupsAcrossLevel = spaceGroupForSiteCount || 0;
    const internalAddressList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'Address' &&
        (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED');
    report.siteData.internalAddress = 0;
    internalAddressList.forEach((address) => {
        const addressProperties = address.properties;
        report.siteData.internalAddress += addressProperties.locationDetails ? addressProperties.locationDetails.length : 0;
    });
    const occupantList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'indoor.Occupant' &&
        (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED');
    report.siteData.occupantAttributes = (0, momUtils_1.getOccupantAttributes)(occupantList);
    const linkedTopologiesList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'indoor.LevelConnector' &&
        (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED');
    report.siteData.linkedTopologies = linkedTopologiesList.length;
    report.siteData.linkedSpaces = 0;
    const routingPoints = internalAddressList.flatMap((address) => address.properties.routingPoints);
    routingPoints.forEach((routePoint) => {
        report.siteData.linkedSpaces += routePoint && ('roadId' in routePoint) ? 1 : 0;
    });
    const topologiesList = (0, lodash_1.filter)(mom.features, (feature) => feature.momType === 'Topology' &&
        (0, momUtils_1.getDeltaChangeState)(feature.properties) !== 'REMOVED');
    const accessCharacteristics = topologiesList.map((topology) => topology.properties.accessCharacteristics);
    report.siteData.topologyAttributes = {
        pedestrian: 0,
        vehicle: 0,
        both: 0,
    };
    accessCharacteristics.forEach((obj) => {
        const accesPropObj = obj && [Object.assign({}, ...obj)];
        if (accesPropObj && accesPropObj.some((b) => b && b.pedestrian && b.motorcycle)) {
            report.siteData.topologyAttributes.both += 1;
        }
        if (accesPropObj && accesPropObj.some((b) => b && !b.pedestrian && b.motorcycle === true)) {
            report.siteData.topologyAttributes.vehicle += 1;
        }
        if (accesPropObj && accesPropObj.some((b) => b && b.pedestrian && !b.motorcycle)) {
            report.siteData.topologyAttributes.pedestrian += 1;
        }
    });
    (0, helper_1.logMsg)('Attribute count report generated successfully!');
    if (!options?.reportInJsonFormat) {
        const siteInfo = `Site,${site?.id}`;
        reportCsv +=
            getOccupantsAttributesCount(report.siteData.occupantAttributes, siteInfo) +
                getSpaceGroupAccrossLevelCount(report.siteData.spaceGroupsAcrossLevel, siteInfo) +
                getInternalAddressCount(report.siteData.internalAddress, siteInfo) +
                getLinkedTopologiesCount(report.siteData.linkedTopologies, siteInfo) +
                getLinkedSpacesCount(report.siteData.linkedSpaces, siteInfo) +
                getTopologyAttributesCount(report.siteData.topologyAttributes, siteInfo);
        return reportCsv;
    }
    return report;
};
exports.generateAttributeCount = generateAttributeCount;
